import { withInstall } from '@bigin/utils'

import Backtop from './src/backtop.vue'

export const BBacktop = withInstall(Backtop)
export default BBacktop

export * from './src/backtop'
